import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";

import { MarketTimeLookupService } from "./MarketTimeLookupService";
import { PrimaryLookupService } from "../../impl/PrimaryLookupService";
import { IMarketTimePromiseLookupService } from "../IMarketTimePromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import { CubiqWorker } from "../../../worker/CubiqWorker";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class MarketTimePrimaryLookupService
  extends PrimaryLookupService<string, CubiqTS.MarketTimeConstantImpl>
  implements IMarketTimePromiseLookupService
{
  constructor(
    protected base: MarketTimeLookupService,
    protected factory: ServiceMessageBrokerFactory,
    protected cubiqWorker: CubiqWorker,
  ) {
    super(base, factory, CubiqTS.MarketTimeConstantImpl, cubiqWorker, "MarketTimeConstantImpl");

    /*   cubiqWorker.isAuth(`${this.constructor.name}`).then(() => {
        let marketTimeObservable = cubiqWorker
            .primeStaticData<CubiqTS.MarketTimeConstantImpl>(CubiqTS.MarketTimeConstantImpl.name);
 
    }, */

    cubiqWorker.isAuth(`${this.constructor.name}`).then(
      () => {
        let marketTimeObservable = cubiqWorker.primeStaticData<CubiqTS.MarketTimeConstantImpl>(
          CubiqTS.MarketTimeConstantImpl.name,
        );

        marketTimeObservable.subscribe(
          (marketTime: CubiqTS.MarketTimeConstantImpl[]) => {
            this.base.prime(marketTime);
          },
          (error: Error) => {
            logger.out.error("Timezone prime failed");
            this._primed.reject(error);
          },
          () => {
            this._primed.resolve(true);
          },
        );
      },
      (reason) => {
        console.debug("TimezonePrimaryLookupService: Failed to prime: " + reason);

        this._primed.resolve(false);
      },
    );

    this.broker.registerMethod(
      "getMarketTime",
      [PRIMITIVE],
      this.getItemKey.bind(this),
      this.VALUE,
    );
    this.broker.registerMethod("getAllMarketTime", [], this.getAllMarketTime.bind(this), PRIMITIVE);
  }

  getMarketTime(id: string): Promise<CubiqTS.MarketTimeConstantImpl> {
    return new Promise<CubiqTS.MarketTimeConstantImpl>((res, rej) => {
      res(this.base.getMarketTime(id));
    });
  }

  getAllMarketTime(): Promise<Array<string>> {
    return new Promise<Array<string>>((res, rej) => {
      res(this.base.getAllMarketTime());
    });
  }
}
